import { legacyPlugins } from "/codebuild/output/src2193415028/src/codestar-connections.eu-west-1.amazonaws.com/git-http/471112859602/eu-west-1/ee15b64b-8c7d-4ab7-b668-2c0ec41dbd39/studyportals/OmniSearch/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}